// Constants
export const NAMESPACE = 'SPRAY_EVENTS_COMPLETE_UPDATE';
export const COMPLETE_SPRAY_EVENT_MODAL = 'completeSprayEventModal';
